export default __webpack_public_path__ + "static/media/monetary-icon.6f0eeb85.svg";